import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';

import { UiCommandEvent } from '@ui/cer-ui-types';

export class DataJobTaskLogErrorForm extends CerFormAdapter {

  public override view(): CerFormView {
    return new CerFormView({
      mandatory: true,
      viewMetadata: {
        dataApiName: 'DataJobTaskLogError',
        name: 'job-task-log-error', text: 'Datajob opgavefejl',
        allowCreate: false, allowEdit: false, allowDelete: false,
        primaryKey: 'id',
        baseFields: ['id'],
        navigations: [
          { link: 'fk', foreignKey: { parentEntity: 'DataJobTaskLog', parentColumn: 'id', column: 'jobTaskLogId'}}
        ]
      },
      fieldMetadata: [
        { name: 'jobTaskLogId', text: 'Opgave', foreignKeyTableName: 'DataJobTaskLog', foreignKeyField: 'id', foreignKeyValue: 'fileName' },
        { name: 'acknowledged', text: 'Kvitteret', format: 'CheckBox', width: '70px', filterOnClient: true, filterOperator: 'notequal', filterValue: true },
        { name: 'errCode', text: 'Fejlkode', format: 'Number0', visible: false },
        { name: 'msgDesc', text: 'Fejl' },
        { name: 'sevNum', text: 'Niveau', format: 'Number0', visible: false },
        { name: 'procNm', text: 'Kode', visible: false },
        { name: 'lineNum', text: 'Linje', format: 'Number0', visible: false },
        { name: 'created', text: 'Oprettet', format: 'DateTime', orderBy: 'Descending', width: '120px' },
        { name: 'modified', text: 'Ændret', format: 'DateTime', visible: false, width: '120px' }
      ],
      contextMenuCommands: [],
      onCommandEvent: (e => this.onCommand(e)),
    });

  }

  // Commands
  public onCommand(event: UiCommandEvent) {
    if (event.actionType == 'init')
    {
      const viewMeta = event.viewMetadata;
      if (viewMeta?.parentForeignKey?.length > 0)
      {
        const f = event.formView.fieldMetadata.find(f => f.name == 'acknowledged');
        if (f) {
          f.filterValue = null;
          f.filterOperator = null;
          f.filterOnClient = false;
        }
      }
    }
  }
}
